<template>
  <div class="container">
   <form style="margin-bottom: 20px;">
      <div>
         <div class="row">
            <div class="col-lg-12 col-md-12">
                    <div class="detail-tab">
                        <!--Nav Button  -->                                            
                        <nav>                                                                     
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <a class="nav-item nav-link" v-on:click="tab=1"   v-bind:class="{'active show': tab==1}" role="tab" aria-controls="nav-1" aria-selected="false">Thông tin</a>
                                <a class="nav-item nav-link" v-on:click="tab=2;info.XacNhanMatKhau=''"  v-bind:class="{'active show': tab==2}"  role="tab" aria-controls="nav-3" aria-selected="true">Đổi mật khẩu</a>
                            </div>
                        </nav>
                        <!--End Nav Button  -->
                    </div>
                </div>
            <template v-if="tab==1">
               <div class="col-lg-6 col-md-6 col-sm-12" v-if="info.IsOrg === false">
                  <div class="login__label">
                     <span>Email<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.Email" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Họ tên<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.HoTen" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Ngày sinh<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <date-picker :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;" required type="text" v-model="info.NgaySinh"   class=""></date-picker>
                  </div>
                  <div class="login__label">
                     <span>Số điện thoại (Nên sử dụng số di động để nhận tin nhắn thông báo khi cần thiết)<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.SoDienThoai" type="text" value="" placeholder="">
                  </div>
               </div>
               <div class="col-lg-6 col-md-6 col-sm-12" v-if="info.IsOrg === true">
                  <div class="login__label">
                     <span>Tên doanh nghiệp/Tổ chức<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.TenToChuc" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Mã số doanh nghiệp/Mã số thuế<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.MaSoThue" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Ngày cấp số doanh nghiệp/Mã số thuế<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <date-picker :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;" required type="text" v-model="info.NgayCapMaSoThue"   class=""></date-picker>
                  </div>
                  <div class="login__label">
                     <span>Nơi cấp MSDN/MST<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.NoiCapMaSoThue" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Trụ sở<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.DiaChi" type="text" value="" placeholder="">
                  </div>
               </div>
               <div class="col-lg-6 col-md-6 col-sm-12" v-if="info.IsOrg === false">
                  <div class="login__label">
                     <span>Số CMND/CCCD<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.SoCMND" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Ngày cấp CMND/CCCD<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <date-picker :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;"  required type="text" v-model="info.NgayCapCMND"   class=""></date-picker>
                  </div>
                  <div class="login__label">
                     <span>Nơi cấp CMND/CCCD<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" type="text" v-model="info.NoiCapCMND" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Địa chỉ<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.DiaChi" type="text" value="" placeholder="">
                  </div>
                  <!-- <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="login__label">
                           <span>Ảnh CMND/CCCD mặt trước<code>*</code></span>
                        </div>
                        <div class="login__row img-detail">
                           <input class="" v-on:change="handleFileUpload1()" ref="file1" type="file" value="" placeholder="">
                           <img v-if="urlCMNDTruoc" :src="urlCMNDTruoc" style="width: 90%;">
                        </div>
                     </div>
                     <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="login__label">
                           <span>Ảnh CMND/CCCD mặt sau<code>*</code></span>
                        </div>
                        <div class="login__row img-detail">
                           <input class="" ref="file2" v-on:change="handleFileUpload2()"  type="file" value="" placeholder="">
                           <img v-if="urlCMNDSau" :src="urlCMNDSau" style="width: 90%;">
                        </div>
                     </div>
                  </div> -->
               </div>
               <div class="col-lg-6 col-md-6 col-sm-12" v-if="info.IsOrg === true">
                  <div class="login__label">
                     <span>Người đại diện pháp luật<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.NguoiDaiDien" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Số CMND/CCCD của người đại diện<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.SoCMND" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Ngày cấp CMND/CCCD của người đại diện<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <date-picker :format="'DD/MM/YYYY'" input-class="login_date" style="width: 100%;"  required type="text" v-model="info.NgayCapCMND"   class=""></date-picker>
                  </div>
                  <div class="login__label">
                     <span>Nơi cấp CMND/CCCD của người đại diện<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" type="text" v-model="info.NoiCapCMND" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Số điện thoại (Nên sử dụng số di động để nhận tin nhắn thông báo khi cần thiết)<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.SoDienThoai" type="text" value="" placeholder="">
                  </div>
                  <div class="login__label">
                     <span>Email (Nên sử dụng email gốc để nhận các thông tin về đấu giá, mã số nộp tiền)<code>*</code></span>
                  </div>
                  <div class="login__row">
                     <input class="register__input login__input" v-model="info.Email" type="text" value="" placeholder="">
                  </div>
                  <!-- <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="login__label">
                           <span>Ảnh CMND/CCCD mặt trước<code>*</code></span>
                        </div>
                        <div class="login__row img-detail">
                           <input class="" v-on:change="handleFileUpload1()" ref="file1" type="file" value="" placeholder="">
                           <img v-if="urlCMNDTruoc" :src="urlCMNDTruoc" style="width: 90%;">
                        </div>
                     </div>
                     <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="login__label">
                           <span>Ảnh CMND/CCCD mặt sau<code>*</code></span>
                        </div>
                        <div class="login__row img-detail">
                           <input class="" ref="file2" v-on:change="handleFileUpload2()"  type="file" value="" placeholder="">
                           <img v-if="urlCMNDSau" :src="urlCMNDSau" style="width: 90%;">
                        </div>
                     </div>
                  </div> -->
               </div>
            <div class=" col-12">
               <button v-on:click="UpdateProfile()" style="min-width: unset;padding: 17px 20px;background-color: #28a745;" type="button" class="btn btn-sm btn-success">Cập nhật</button>
            </div>
            </template>
            <template v-else>
            <div class="col-lg-6 col-md-6 col-sm-12">
               <div class="login__label">
                  <span>Mật khẩu cũ<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="password" v-model="info.MatKhauCu"  value="" placeholder="">
               </div>
               <div class="login__label">
                  <span>Mật khẩu mới<code>*</code></span>
               </div>
               <div class="login__row">
                  <input style="margin-bottom: 0px;" class="register__input login__input" v-model="info.MatKhauMoi"  type="password" value="" placeholder="">
                  <code>Mật khẩu phải chứa ít nhất 1 chữ hoa, 1 chữ thường, 1 chữ số và có độ dài trên 6 ký tự </code>
               </div>
               <div class="login__label">
                  <span>Xác nhận mật khẩu mới<code>*</code></span>
               </div>
               <div class="login__row">
                  <input class="register__input login__input" type="password" v-model="info.XacNhanMatKhau"  value="" placeholder="">
               </div>
            </div>
            <div class=" col-12">
               <button v-on:click="changePass()" style="min-width: unset;padding: 17px 20px;background-color: #28a745;" type="button" class="btn btn-sm btn-success">Cập nhật</button>
            </div>
            </template>
         </div>
      </div>
      
      <div class="wpcf7-response-output wpcf7-display-none"></div>
      </form>
  </div>
</template>

<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import mixin from '@/mixins/mixin.js'
import { mapGetters } from "vuex";
import User from '@/common/api/user'
export default {
  components: {DatePicker},
  mixins: [mixin],
  name: 'Profile',
  data () {
    return {
       tab: 1,
        info: {
            MatKhauCu: '',
            MatKhauMoi: '',
            XacNhanMatKhau: ''
        },
    }
  },
   computed: {
    ...mapGetters(["currentUser", "isAuthenticated"]),
  },
  created(){
     this.getInfo()
  },
  methods: {
     UpdateProfile(){
        this.info.MatKhau = '1';
        this.info.XacNhanMatKhau = '1';
        this.info.NgaySinh = moment(String(this.info.NgaySinh)).format('MM/DD/YYYY');
        this.info.NgayCapCMND = moment(String(this.info.NgayCapCMND)).format('MM/DD/YYYY');
        if(this.info.IsOrg === false) {
           User.UpdateProfile(this.info).then(({ data }) => {
           if (data.Message && data.Message != ''){
              this.$swal.fire(
                  {
                  title: 'Lỗi!',
                  text: data.Message,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
                  }
               )
           }else{
              this.$swal.fire(
                  {
                  title: 'Thành công!',
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
                  }
               )
           }
        })
        } else {
           this.info.NgayCapMaSoThue = moment(String(this.info.NgayCapMaSoThue)).format('MM/DD/YYYY');
           User.UpdateProfileBusiness(this.info).then(({ data }) => {
           if (data.Message && data.Message != ''){
              this.$swal.fire(
                  {
                  title: 'Lỗi!',
                  text: data.Message,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
                  }
               )
           }else{
              this.$swal.fire(
                  {
                  title: 'Thành công!',
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
                  }
               )
           }
        })
        }
        
     },
     getInfo(){
      User.get(this.currentUser.id).then(({ data }) => {
         this.info = data.Data
         this.info.NgaySinh = new Date(this.info.NgaySinh)
         this.info.NgayCapCMND = new Date(this.info.NgayCapCMND)
         this.info.NgayCapMaSoThue = new Date(this.info.NgayCapMaSoThue)
        })
      },
     changePass(){
         var mess = ''
         var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})");
         if(!this.info.MatKhauCu || this.info.MatKhauCu == ''){
             mess = "Mật khẩu cũ không được để trống"
         }else if(!this.info.MatKhauMoi || this.info.MatKhauMoi == ''){
            mess = "Mật khẩu mới không được để trống"
         }else if(this.info.MatKhauMoi != this.info.XacNhanMatKhau){
            mess = "Nhập lại mật khẩu không đúng"
         }

         if(!strongRegex.test(this.info.MatKhauMoi)) {
            mess = 'Mật khẩu mới không đúng định dạng'
         }

         if (mess != ''){
            this.$swal.fire(
               {
                  title: 'Lỗi!',
                  text: mess,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
               }
            )
            return;
        }

        User.changePassword(this.currentUser.id, this.info.MatKhauMoi)
        .then(({ data }) => {
            this.$swal.fire(
               {
                  title: 'Thành công!',
                  text: "",
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'Đồng ý',
               }
            )
            this.info = {
                MatKhauCu: '',
                MatKhauMoi: '',
                XacNhanMatKhau: ''
            }
        })
     },
  },
}
</script>

<style scoped>
.register__input {
   height: 34px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Profile.vue